export default __webpack_public_path__ + "static/media/img-b-03-360-arrow.0cb3b6b5.svg";